import { Outlet, useLocation } from 'react-router-dom'
import { ProtectedRoute } from '../components/ProtectedRoute'
import { Navbar } from '../components/layout/Navbar'
import { Sidebar } from '../components/layout/Sidebar'
import { useOrganizationLoader } from '../hooks/useOrganizationLoader'
import { matchDashboardTitle } from './dashboardTitle'

function DashboardShell() {
  const { pathname } = useLocation()
  const { title, subtitle } = matchDashboardTitle(pathname)
  useOrganizationLoader()

  return (
    <div className="relative flex h-dvh overflow-hidden bg-background text-foreground">
      <div className="pointer-events-none fixed inset-0 overflow-hidden">
        <div className="absolute -top-40 -right-40 h-96 w-96 rounded-full bg-primary/20 blur-3xl float-animation" />
        <div
          className="absolute top-1/2 -left-40 h-80 w-80 rounded-full bg-accent/15 blur-3xl float-animation-delayed"
        />
        <div className="absolute -bottom-40 right-1/3 h-72 w-72 rounded-full bg-primary/10 blur-3xl float-animation-slow" />
      </div>
      <Sidebar />
      <div className="relative z-10 flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden">
        <Navbar title={title} subtitle={subtitle} />
        <main className="min-h-0 flex-1 overflow-y-auto overscroll-y-contain px-4 py-6 sm:px-6 lg:px-8 lg:py-8">
          <div className="mx-auto w-full max-w-7xl">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  )
}

export function DashboardLayout() {
  return (
    <ProtectedRoute>
      <DashboardShell />
    </ProtectedRoute>
  )
}
